(function(){
  function update(el){
    const m = el.textContent.match(/\d+/);
    if(m) el.textContent = `(${m[0]})`;
  }
  function updateAll(){
    document.querySelectorAll('.reputon-reviews-count').forEach(update);
  }
  updateAll();
  const obs = new MutationObserver(muts => {
    for(const m of muts){
      for(const n of m.addedNodes){
        if(n.nodeType!==1) continue;
        if(n.matches('.reputon-reviews-count')){
          update(n);
        } else {
          n.querySelectorAll('.reputon-reviews-count').forEach(update);
        }
      }
    }
  });
  obs.observe(document.body, { childList: true, subtree: true });
})();

/* Mobile nav: tapping the whole row toggles submenu instead of navigating */
(function() {
  document.addEventListener('DOMContentLoaded', function() {
    var mobileNav = document.getElementById('MobileNav');
    if (!mobileNav) return;

    mobileNav.addEventListener('click', function(e) {
      /* If the click came from the icon itself, let theme.js handle it alone */
      if (e.target.closest('.at')) return;

      var link = e.target.closest('a');
      if (!link) return;

      var icon = link.querySelector('.at');
      if (!icon) return; /* no icon = no children, let normal navigation happen */

      e.preventDefault();
      e.stopPropagation();
      icon.classList.toggle('at-plus-l');
      icon.classList.toggle('at-minus-l');
      $(link).parent().children('ul').slideToggle();
    });
  });
})();